<template>
  <article class="tile is-child box">
    <h4 class="title"><strong>Missing Bookings</strong></h4>
    <div class="control is-vertical">
      <div class="control is-grouped">
        <p class="control">
          <label class="label">Search</label>
          <input class="input" type="text" name="search" id="search" placeholder="Search" v-model="filter.search" >
        </p>
        <p class="control">
          <label class="label">Date Created From</label>
          <datepicker ref="createdFrom" placeholder="Date Created From"></datepicker>
        </p>
        <p class="control">
          <label class="label">To</label>
          <datepicker ref="createdTo" placeholder="Date Created To"></datepicker>
        </p>
        <p class="control">
          <a style="margin-top: 24px;" class="button is-info is-pulled-right" @click="clear(true)">
            <span class="icon"><i class="fa fa-eraser"></i></span>
            <span> Clear</span>
          </a>
        </p>
        <p class="control">
          <a style="margin-top: 24px;" class="button is-primary is-pulled-right" @click="search()">
            <span class="icon"><i class="fa fa-search"></i></span>
            <span> Search</span>
          </a>
        </p>
      </div>
    </div>
    <div class="table-responsive">
      <hyper-table :url="url" :columns="getColumns()" tableClass="table is-bordered is-striped is-narrow" :appendParams="filter" v-on:selected="selected($event)" v-on:sort="sort($event)" v-on:perPage="perPage($event)">
      </hyper-table>
    </div>
  </article>
</template>

<script>
  import HyperTable from '../../components/hyper-table/HyperTable.vue'
  import Datepicker from 'vue-bulma-datepicker'
  export default {
    data () {
      return {
        filter: {
          sort: {
            field: 'created_at',
            direction: 'asc'
          },
          filter: {
            search: '',
            per_page: 10,
            createdFrom: '',
            createdTo: ''
          },
          per_page: 10
        },
        url: 'bookings_missing'
      }
    },
    beforeMount () {
    },
    mounted () {
      this.$nextTick(() => {
        this.$children[2].loadData(true)
      })
    },
    methods: {
      getColumns () {
        let columns = []
        columns = [
          {
            title: {
              caption: 'Action',
              columnClass: ''
            },
            content: {
              type: 'field-component',
              data: 'bookings-missing-table-buttons',
              fieldClass: 'has-text-centered'
            }
          },
          {
            title: {
              caption: 'Booking',
              columnClass: ''
            },
            content: {
              data: 'booking',
              sort: 'booking',
              fieldClass: ''
            }
          },
          {
            title: {
              caption: 'Client',
              columnClass: ''
            },
            content: {
              data: 'client',
              sort: 'client',
              fieldClass: ''
            }
          },
          {
            title: {
              caption: 'Customer Booking',
              columnClass: ''
            },
            content: {
              data: 'customer_booking',
              sort: 'customer_booking',
              fieldClass: ''
            }
          },
          {
            title: {
              caption: 'Hotel',
              columnClass: ''
            },
            content: {
              data: 'hotel',
              sort: 'hotel',
              fieldClass: ''
            }
          },
          {
            title: {
              caption: 'Destination',
              columnClass: ''
            },
            content: {
              data: 'destination',
              sort: 'destination',
              fieldClass: ''
            }
          },
          {
            title: {
              caption: 'Token',
              columnClass: ''
            },
            content: {
              data: 'token',
              sort: 'token',
              fieldClass: ''
            }
          },
          {
            title: {
              caption: 'Created',
              columnClass: ''
            },
            content: {
              data: 'create_date',
              sort: 'create_date',
              fieldClass: ''
            }
          }
        ]
        return columns
      },
      reload () {
        this.$children[2].loadData(true)
      },
      search () {
        this.filter.createdFrom = this.$refs.createdFrom.datepicker.input.value
        this.filter.createdTo = this.$refs.createdTo.datepicker.input.value
        this.$children[2].loadData(true)
      },
      clear () {
        this.$refs.createdFrom.datepicker.input.value = ''
        this.$refs.createdTo.datepicker.input.value = ''
        this.filter.search = ''
      },
      parseStatus (status) {
        return this.$store.state.config.status[status].name
      },
      sort (sort) {
        this.filter.sort = sort
      },
      perPage (page) {
        this.filter.per_page = page
      },
      parseDate (content) {
        if (content) {
          return this.$moment(content).format('YYYY-MM-DD')
        } else {
          return ''
        }
      },
      getSelected () {
        return this.selectedItens.length
      },
      selected (event) {
        this.selectedItens = event
      }
    },
    components: {
      HyperTable,
      Datepicker
    }
  }
</script>

<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }
</style>



// WEBPACK FOOTER //
// BookingsMissing.vue?722810a6